import React from "react";
import ReportTable from "./ReportTable";

const ReportLoadingState = ({
  title = "Rapor Hazırlanıyor",
  description = "Verileriniz yükleniyor, lütfen bekleyin...",
  progressText = "Veriler işleniyor...",
  showTableSkeleton = true,
  skeletonRows = 5,
  skeletonColumns = 7,
  tableTitle = "Veri Listesi",
  tableCount = 0,
  tableCountText = "kayıt bulundu",
  tableColumns = [],
}) => {
  // If we have table columns, use ReportTable skeleton
  if (showTableSkeleton && tableColumns.length > 0) {
    return (
      <ReportTable
        title={tableTitle}
        count={tableCount}
        countText={tableCountText}
        columns={tableColumns}
        data={[]}
        isLoading={true}
        skeletonRows={skeletonRows}
      />
    );
  }

  // Fallback to original loading state
  return (
    <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden mb-6">
      {/* Loading Header */}
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-6 text-center text-white">
        <div className="flex flex-col items-center gap-4">
          <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          <div>
            <h3 className="text-xl font-bold">{title}</h3>
            <p className="text-blue-100 mt-1">{description}</p>
          </div>
        </div>
      </div>

      {/* Loading Content - Skeleton Table */}
      {showTableSkeleton && (
        <div className="p-6">
          {/* Table Header Skeleton */}
          <div className="mb-4">
            <div className="h-12 bg-gray-200 rounded-xl animate-pulse"></div>
          </div>

          {/* Skeleton Rows */}
          {[...Array(skeletonRows)].map((_, index) => (
            <div key={index} className="mb-3">
              <div className="flex gap-3">
                {[...Array(skeletonColumns)].map((_, colIndex) => (
                  <div
                    key={colIndex}
                    className="h-8 bg-gray-200 rounded-lg animate-pulse flex-1"
                    style={{
                      animationDelay: `${index * 0.1 + colIndex * 0.1}s`,
                    }}
                  ></div>
                ))}
              </div>
            </div>
          ))}

          {/* Progress Indicator */}
          <div className="mt-6 text-center">
            <p className="text-gray-600 mb-3 font-medium">{progressText}</p>
            <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
              <div className="h-full bg-gradient-to-r from-blue-600 to-purple-600 rounded-full animate-pulse"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportLoadingState;
